<div *ngIf="loading" class="d-flex justify-content-center align-items-center my-5 w-100">
  <div class="text-muted">Loading user journeys…</div>
</div>

<!-- Contenu principal affiché uniquement s'il n'y a pas d'erreur globale -->
<div *ngIf="!loading && (!workflows || workflows.length === 0) && !errorMsg" class="d-flex justify-content-center align-items-center my-5 w-100">
  <div class="error-container">
    <div class="error-icon-container">
      <mat-icon class="error-icon">route</mat-icon>
    </div>
    <div class="error-content">
      <h3 class="error-title">No User Journeys</h3>
      <p class="error-description">You haven't created any User Journeys yet.</p>
      <div class="d-flex justify-content-center">
        <button class="btn btn-track mt-2" (click)="navigateToMyAccount()">
          <mat-icon>add</mat-icon>
          <span class="ms-1">Create your first journey</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!errorMsg && workflows.length > 0" class="graph m-5 p-4">
  <!-- Display selected workflow details -->
  <div *ngIf="selectedWorkflow" class="d-flex justify-content-center align-items-center">
    <h2>{{ selectedWorkflow.name | titlecase }} - User Journey</h2>
  </div>

  <div *ngIf="workflows && workflows.length > 0" class="d-flex justify-content-between align-items-center">
    <!-- Workflow selection using MatSelect -->
    <mat-form-field appearance="outline" *ngIf="workflows.length > 1">
      <mat-label>Select a CRUX Workflow</mat-label>
      <mat-select [(ngModel)]="selectedWorkflow" (selectionChange)="selectWorkflow($event.value)">
        <mat-option *ngFor="let wf of workflows" [value]="wf">
          {{ wf.name | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="radio-inputs">
      <label class="radio">
        <input
          type="radio"
          [name]="'radio'"
          value="mobile"
          [(ngModel)]="device"
          (change)="setDeviceUrl($event)"
        />
        <span class="name">Mobile</span>
      </label>
      <label class="radio">
        <input
          type="radio"
          [name]="'radio'"
          value="desktop"
          [(ngModel)]="device"
          (change)="setDeviceUrl($event)"
        />
        <span class="name">Desktop</span>
      </label>
    </div>
  </div>

  <!-- Chart header -->
  <div class="chart-header" *ngIf="chartOptions && !loading">
    <mat-icon class="reading-arrow">arrow_downward</mat-icon>
    <span>Reading Direction</span>
  </div>

  <!-- Chart display -->
  <div *ngIf="!loading" id="chartdiv" class="my-5" style="width: 100%; height: 300px;"></div>

  <!-- Message d'erreur spécifique au chart (URLs invalides, etc.) -->
  <div *ngIf="chartErrorMsg" class="alert alert-danger mb-3">
    {{ chartErrorMsg }}
  </div>
</div>

<!-- Affichage du message d'erreur global -->
<div *ngIf="errorMsg" class="alert alert-danger m-5 p-4 text-center">
  {{ errorMsg }}
</div>
